export default __webpack_public_path__ + "static/media/amzDsv.72289d3c.svg";